export default {
    NOTIFICATION(state, body) {
                
        state.notification.icon = body.type;
        state.notification.title = body.message;
    },
    FETCH_PAGE_NOTIFICATIONS(state, payload) {
        if(payload.response.status == 200) {
            
            if(payload.index == 1)
                state.allNotifications = payload.response.data.notifications.data;
            else
                state.allNotifications = state.allNotifications.concat(
                    payload.response.data.notifications.data
                );
        
            state.lastNotificationsPageIndex = payload.response.data.notifications.last_page;
        }
        state.isLoading = false;
    }
}
